<template>
  <div>
    <div v-if="!loading && credit_cards">
      <li v-for="(credit_card) in credit_cards.data"
          :key="credit_card.id"

          class="p-list__item p-list__content"
      >
        <div class="c-radio__item">
          <input
            :id="credit_card.id"
            type="radio"
            name="card_id"
            class="default-card-change-button c-radio__input"
            :value="credit_card.id"
            :checked="credit_card.id == default_card_id"
            @change="onChange(credit_card.id)"
          >
          <label :for="credit_card.id" class="c-radio__label" />
        </div>
        <div class="p-creditCard__list__items__content">
          <div class="p-creditCard__list__items__card" :class="{ 'is-active': credit_card.id == default_card_id }">
            <span class="p-creditCard__list__items__card__item">
              <img :src="cardImg(credit_card.attributes.brand)" alt="" class="card-img">
            </span>
            <span class="p-creditCard__list__items__card__item p-creditCard__list__items__card__brand">
              {{ credit_card.attributes.brand }}
            </span>
            <span class="p-creditCard__list__items__card__item">
              {{ $t('pages.companies.paymentSetting.paymentMethod.creditCard.lastDigit') }} {{ credit_card.attributes.last4 }}
            </span>
            <p>{{ $t('pages.companies.paymentSetting.paymentMethod.creditCard.name') }} {{ credit_card.attributes.name }}</p>
            <span class="p-creditCard__list__items__card__item">
              {{ $t('pages.companies.paymentSetting.paymentMethod.creditCard.expirationDate') }} {{ credit_card.attributes.exp_month }}/{{ credit_card.attributes.exp_year }}
            </span>
          </div>
          <div v-show="credit_card.id != default_card_id" class="c-button__item card-delete-button" @click="onClick(credit_card.id)">
            <div class="c-button__icon">
              <img :src="imgIconCross" alt="">
            </div>
            {{ $t('labels.delete') }}
          </div>
        </div>
      </li>
    </div>
    <Loading v-show="loading" />
  </div>
</template>

<script>
import ImgIconCross from '../../../../images/common/icon_cross.svg'
import {mapActions, mapState} from 'vuex'
import Loading from '../Loading'
import ImgIconAmex from '../../../../images/credit_cards/amex.gif'
import ImgIconDiners from '../../../../images/credit_cards/diners.gif'
import ImgIconDiscover from '../../../../images/credit_cards/discover.gif'
import ImgIconJcb from '../../../../images/credit_cards/jcb.gif'
import ImgIconMasterCard from '../../../../images/credit_cards/mastercard.gif'
import ImgIconVisa from '../../../../images/credit_cards/visa.gif'

export default {
  name: 'CreditCard',
  components: {Loading},
  computed: {
    ...mapState({
      credit_cards: state => state.companiesCreditCards.data,
      default_card_id: state => state.companiesCreditCards.default_card_id,
      loading: state => state.companiesCreditCards.loading
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
    imgIconCross() {
      return ImgIconCross
    },
  },
  created() {
    this.readCreditCards(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readCreditCards: 'companiesCreditCards/readCreditCards',
      deleteCreditCards: 'companiesCreditCards/deleteCreditCards',
      changeDefaultCreditCards: 'companiesCreditCards/changeDefaultCreditCards',
    }),
    onClick(card_id) {
      if (confirm(this.$t('pages.companies.paymentSetting.paymentMethod.creditCard.confirmToDelete'))) {
        this.deleteCreditCards({companyUuid: this.currentCompanyUuid, card_id: card_id})
      }
    },
    onChange(card_id) {
      if (confirm(this.$t('pages.companies.paymentSetting.paymentMethod.creditCard.confirmToChange'))) {
        this.changeDefaultCreditCards({companyUuid: this.currentCompanyUuid, card_id: card_id})
      }
    },
    cardImg(brand) {
      switch (brand) {
      case 'Visa':
        return ImgIconVisa
      case 'MasterCard':
        return ImgIconMasterCard
      case 'JCB':
        return ImgIconJcb
      case 'American Express':
        return ImgIconAmex
      case 'Diners Club':
        return ImgIconDiners
      case 'Discover':
        return ImgIconDiscover
      default:
        return null
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.card-img {
  width: 33px;
  height: 23px;
}
</style>
